import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DisplayModes } from '../../../models/enums';
import { ActivatedRoute, Router } from '@angular/router';
import { AppTranslationService } from '../../../services/app-translation.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { GiveawayStock } from '../giveaway-stock.model';
import { GiveawayStockService } from '../giveaway-stock.service';
import { AccountService } from '../../../services/account.service';
import { GiveawayItemService } from '../../services/giveaway-item.service';
import { GiveawayItem } from '../../models/giveaway-item.model';

@Component({
  selector: 'crm-save-giveaway-stock',
  templateUrl: './save-giveaway-stock.component.html',
  styleUrls: ['./save-giveaway-stock.component.css']
})
export class SaveGiveawayStockComponent implements OnInit {

  stock: GiveawayStock = new GiveawayStock();
  giveawayItems: GiveawayItem[] = [];
  displayMode: DisplayModes = DisplayModes.Success;
  userId: number = 0;
  user: any;
  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() stockId: number;
  constructor(private readonly accountService: AccountService,
    private readonly giveawayStockService: GiveawayStockService,
    private readonly giveawayItemService: GiveawayItemService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly translateService: AppTranslationService,
    private readonly alertService: AlertService) { }

  ngOnInit() {
    this.getGiveaways();
    if (this.stockId != undefined)
      this.getGiveawayStock(this.stockId);
  }

  getGiveaways() {
    this.giveawayItemService.getAll().subscribe(responce => {
      this.giveawayItems = responce as GiveawayItem[];
      if (this.stock && this.stock.giveawayItem)
        this.stock.giveawayItem = this.giveawayItems.find(x => { return x.id == this.stock.giveawayItemId });
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get items');
        console.log(err)
      });
  }

  getGiveawayStock(id) {
    this.displayMode = DisplayModes.Loading;
    this.giveawayStockService.getById(id).subscribe(responce => {
      this.displayMode = DisplayModes.Success;
      this.stock = responce as GiveawayStock;
      if (this.giveawayItems && this.giveawayItems.length > 0)
        this.stock.giveawayItem = this.giveawayItems.find(x => { return x.id == this.stock.giveawayItemId });
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get giveaway stock');
        console.log(err);
      });
  }

  save(form) {
    if (!form.invalid) {
      this.displayMode = DisplayModes.Loading;
      if (this.stock.giveawayItem !== undefined && this.stock.giveawayItem !== null) {
        this.stock.giveawayItemId = this.stock.giveawayItem.id;
      }

      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
      this.giveawayStockService.save(this.stock).subscribe(() => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        this.back();
        this.alertService.showMessage("", this.translateService.getTranslation("clm.savedSuccessfully"), MessageSeverity.Success);
      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
    }
  }

  back() {
    this.closeEvent.emit(true);
  }

}
